import { useNavigate } from "react-router-dom";
import { Button } from "../ui";

interface ProductCardProps {
  id: number;
  name: string;
  image: string;
  price: string;
  oldPrice?: string;
  hasStock: boolean;
  isUnlimited?: boolean;
  discount?: number;
  sku: string;
  onAddToCart?: () => void;
}

export const ProductCard = ({
  id,
  name,
  image,
  price,
  oldPrice,
  hasStock,
  isUnlimited,
  discount = 0,
  sku,
}: ProductCardProps) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    if (hasStock) {
      navigate(`/product/${id}-${sku}`);
    }
  };

  return (
    <div className='bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full'>
      <div className='relative'>
        <img src={image} alt={name} className='w-full h-48 object-cover' />
        {discount > 0 && (
          <div className='absolute top-2 right-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded'>
            -{discount}%
          </div>
        )}
      </div>

      <div className='p-4 flex flex-col flex-grow'>
        <h3 className='text-lg font-semibold text-gray-800 mb-1 line-clamp-2'>{name}</h3>

        {/* Updated availability display */}
        {hasStock ? (
          isUnlimited ? (
            <p className='text-sm text-green-600 mb-2'>Unlimited</p>
          ) : (
            <p className='text-sm text-green-600 mb-2'>In Stock</p>
          )
        ) : (
          <p className='text-sm text-red-500 mb-2'>Out of Stock</p>
        )}

        <div className='mt-auto'>
          <div className='flex items-center mb-2'>
            <span className='text-primary font-bold text-sm'>
              ₦{parseFloat(price).toLocaleString()}
            </span>
            {oldPrice && parseFloat(oldPrice) > parseFloat(price) && (
              <span className='text-gray-400 text-xs line-through ml-2'>
                ₦{parseFloat(oldPrice).toLocaleString()}
              </span>
            )}
          </div>

          <Button
            onClick={handleViewDetails}
            disabled={!hasStock}
            className={`w-full ${
              !hasStock ? "bg-gray-200 hover:bg-gray-200 cursor-not-allowed text-black" : ""
            }`}
            size='sm'
          >
            {hasStock ? "View Details" : "Out of Stock"}
          </Button>
        </div>
      </div>
    </div>
  );
};
